var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.DocumentTypeId && _vm.ObjectId)?_c('div',[_c('dropzone',{ref:"dropZoneUpload",attrs:{"id":"myVueDropzone","duplicateCheck":true,"useCustomSlot":true,"options":_vm.dropzoneOptions},on:{"vdropzone-queue-complete":_vm.queueComplete}},[_vm._v("\n    "+_vm._s(_vm.$t('UPLOAD_TEXT'))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }